<app-common-loader *ngIf="carregandoTarefas"></app-common-loader>
<div class="shared-container">
  <div class="modal-container">
    <div class="modal-header">
      <div class="d-flex box-header">
        <h2 class="modal-title">AGENDAR TAREFA</h2>
        <button class="btn-close" (click)="fecharModal()">x</button>
      </div>

      <p class="modal-subtitle">
        Preencha todos os campos para agendar uma nova tarefa.
      </p>

      <p class="modal-contato" *ngIf="contatoInfo?.nome">
        Contato: <b>{{ contatoInfo.nome }}</b>
        <span *ngIf="contatoInfo.cargo"> — {{ contatoInfo.cargo }}</span>
      </p>
    </div>
    <div class="modal-body">
      <label for="taskDescription">DESCREVA A TAREFA *</label>
      <textarea
        id="taskDescription"
        [(ngModel)]="description"
        class="form-control"
        [ngClass]="{ 'is-invalid': campoObrigatorioErro && !description }"
        placeholder="Descreva a tarefa aqui..."
      ></textarea>
      <div
        *ngIf="campoObrigatorioErro && !description"
        class="campo-obrigatorio-msg"
      >
        Campo obrigatório!
      </div>

      <label for="responsavel">RESPONSÁVEL *</label>
      <select
        id="responsavel"
        [(ngModel)]="responsibleID"
        class="form-control"
        [ngClass]="{ 'is-invalid': campoObrigatorioErro && !responsibleID }"
      >
        <option value="" disabled>Selecione um responsável</option>
        <option *ngFor="let r of responsavel" [value]="r.id">
          {{ r.name }}
        </option>
      </select>
      <div
        *ngIf="campoObrigatorioErro && !responsibleID"
        class="campo-obrigatorio-msg"
      >
        Campo obrigatório!
      </div>

      <label for="obra">OBRA *</label>
      <select
        id="obra"
        [(ngModel)]="selectedObra"
        class="form-control"
        [ngClass]="{ 'is-invalid': campoObrigatorioErro && !selectedObra }"
      >
        <option value="" disabled>Selecione uma obra</option>
        <option *ngFor="let obra of obras" [value]="obra.workID">
          {{ obra.workName }}
        </option>
      </select>
      <div
        *ngIf="campoObrigatorioErro && !selectedObra"
        class="campo-obrigatorio-msg"
      >
        Campo obrigatório!
      </div>

      <label for="tarefa">TIPO DE TAREFA *</label>
      <select
        id="tarefa"
        [(ngModel)]="actionID"
        class="form-control"
        [ngClass]="{ 'is-invalid': campoObrigatorioErro && !actionID }"
      >
        <option value="" disabled>Escolher Tarefa</option>
        <option *ngFor="let r of tarefas" [value]="r.id">
          {{ r.description }}
        </option>
      </select>
      <div
        *ngIf="campoObrigatorioErro && !actionID"
        class="campo-obrigatorio-msg"
      >
        Campo obrigatório!
      </div>

      <div class="date-time">
        <div>
          <label for="data">DATA *</label>
          <input
            id="data"
            type="date"
            [(ngModel)]="data"
            class="form-control"
            [min]="today"
            [ngClass]="{ 'is-invalid': campoObrigatorioErro && !data }"
          />
          <div
            *ngIf="campoObrigatorioErro && !data"
            class="campo-obrigatorio-msg"
          >
            Campo obrigatório!
          </div>
        </div>
        <div>
          <label for="hora">HORA *</label>
          <input
            id="hora"
            type="time"
            [(ngModel)]="hora"
            class="form-control"
            [ngClass]="{ 'is-invalid': campoObrigatorioErro && !hora }"
          />
          <div
            *ngIf="campoObrigatorioErro && !hora"
            class="campo-obrigatorio-msg"
          >
            Campo obrigatório!
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        class="btn btn-secondary btn-cancelar"
        (click)="limparCampos(); fecharModal()"
      >
        Cancelar
      </button>
      <button class="btn btn-primary btn-criar" (click)="criarTarefa()">
        Criar tarefa
      </button>
    </div>
  </div>
</div>
